//=====================================================
//　診療時間モーダル
//=====================================================

import { useContext } from 'react';
import { CtxClinicInfo } from '../../utils/Contexts';

interface IFProps{
    showModal: boolean,
    closeCallBack: any
}

export function HeaderConsulHoursModal(props: IFProps) {

    const cci = useContext(CtxClinicInfo);

    if ( props.showModal ){
        if (cci.data.consultationHoursImage){
            //診療時間画像表示
            return (
                <>
                    <div className="modal-dental-hours">
                        <div className="modal-dental-hours-inner">
                            <img src={cci.data.consultationHoursImage} alt="診療時間表" className="modal-dental-hours-img" />
                            <div className="btn-modal-close" onClick={props.closeCallBack}>閉じる</div>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className="modal-dental-hours">
                        <div className="modal-dental-hours-inner">
                            <dl className="clinic_info-service">
                                {cci.data.consultationHours &&
                                    <>
                                        <dt>診療時間</dt>
                                        <dd className="clinic_info-hours text-multiline">{cci.data.consultationHours}</dd>
                                    </>
                                }
                                {cci.data.closedDays &&
                                    <>
                                        <dt>休診日</dt>
                                        <dd className="clinic_info-closed text-multiline">{cci.data.closedDays}</dd>
                                    </>
                                }
                            </dl>
                            <div className="btn-modal-close" onClick={props.closeCallBack}>閉じる</div>
                        </div>
                    </div>
                </>
            )
        }
    } else {
        return null;
    }

}